export function withoutCheckoutParameter(value) {
  const url = new URL(value)
  url.searchParams.delete("checkout")
  return url.toString()
}

export function withCheckoutCompletedParameter(value, credits) {
  const url = new URL(value)
  url.searchParams.set("payment", "completed")
  if (Number.isInteger(credits) && credits > 0) url.searchParams.set("credits", credits)
  return url.toString()
}

export function withoutCheckoutCompletedParameter(value) {
  const url = new URL(value)
  url.searchParams.delete("payment")
  url.searchParams.delete("credits")
  return url.toString()
}
